<template>
  <div class="sidebar">
    <!-- <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.index"
                :key="subItem.index"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu> -->
    <!-- 使用递归渲染组件，实现无限级导航 -->
    <!-- 导航展开折叠暂时不需要 -->
    <!-- :collapse="Boolean(collapse)" -->
    <el-menu
      v-show="!Boolean(collapse)"
      class="sidebar-el-menu"
      :default-active="onRoutes"
      background-color="#1b3162"
      mode="vertical"
      text-color="#a3d4ff"
      active-text-color="#fff"
      unique-opened
      router
    >
      <Menu :routerList="items"></Menu>
    </el-menu>
  </div>
</template>

<script>
import bus from '../common/bus';
import Menu from './menusFFF'; // 引进菜单模板
export default {
  data() {
    return {
      collapse: true,
      // items: [
      //   {
      //     icon: 'el-icon-lx-home',
      //     index: '/yanshi',
      //     title: '演示',
      //     subs: [
      //       {
      //         icon: 'el-icon-lx-home',
      //         index: '/Dashboard',
      //         title: '系统首页',
      //       },
      //       {
      //         icon: 'el-icon-lx-cascades',
      //         index: '/BaseTable',
      //         title: '基础表格',
      //       },
      //       {
      //         icon: 'el-icon-lx-copy',
      //         index: '/Tabs',
      //         title: 'tab选项卡',
      //       },
      //       {
      //         icon: 'el-icon-lx-calendar',
      //         index: '/3',
      //         title: '表单相关',
      //         subs: [
      //           {
      //             index: '/BaseForm',
      //             title: '基本表单',
      //           },
      //           {
      //             index: '/3-2',
      //             title: '三级菜单',
      //             subs: [
      //               {
      //                 index: '/VueEditor',
      //                 title: '富文本编辑器',
      //               },
      //               {
      //                 index: '/Markdown',
      //                 title: 'markdown编辑器',
      //               },
      //             ],
      //           },
      //           {
      //             index: '/Upload',
      //             title: '文件上传',
      //           },
      //         ],
      //       },
      //       {
      //         icon: 'el-icon-lx-emoji',
      //         index: '/Icon',
      //         title: '自定义图标',
      //       },
      //       {
      //         icon: 'el-icon-pie-chart',
      //         index: '/BaseCharts',
      //         title: 'schart图表',
      //       },
      //       {
      //         icon: 'el-icon-rank',
      //         index: '/6',
      //         title: '拖拽组件',
      //         subs: [
      //           {
      //             index: '/DragList',
      //             title: '拖拽列表',
      //           },
      //           {
      //             index: '/DragDialog',
      //             title: '拖拽弹框',
      //           },
      //         ],
      //       },
      //       {
      //         icon: 'el-icon-lx-global',
      //         index: '/i18n',
      //         title: '国际化功能',
      //       },
      //       {
      //         icon: 'el-icon-lx-warn',
      //         index: '/7',
      //         title: '错误处理',
      //         subs: [
      //           {
      //             index: '/permission',
      //             title: '权限测试',
      //           },
      //           {
      //             index: '/404',
      //             title: '404页面',
      //           },
      //         ],
      //       },
      //       {
      //         icon: 'el-icon-lx-redpacket_fill',
      //         index: '/404',
      //         title: '全局404',
      //       },
      //     ],
      //   },
      // ],
      items: JSON.parse(localStorage.getItem('setMenus')),
    };
  },
  components: {
    Menu,
  },
  computed: {
    onRoutes() {
      // 如果路由不继承目录就加‘/’ 如果继承则去掉'/'
      return '/' + this.$route.path.replace('/', '');
    },
  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', (msg) => {
      // debugger;
      this.collapse = msg;
      bus.$emit('collapse-content', msg);
    });
  },
};
</script>

<style scoped lang="less">
.sidebar {
  display: block;
  position: fixed;
  left: 0;
  top: 80px;
  bottom: 0;
  overflow-y: scroll;
  background: #fbfcff;
  z-index: 9999;
  // padding-top: 14px;
  border-right: 2px solid #e3eaf4;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  /* width: 240px; */
  min-width: 240px;
}
.sidebar > ul {
  height: 100%;
}
.el-menu {
  border-right: 0;
}
</style>
